(function () {
  'use strict';

  function OrdersController (Common, $state, $scope, ordersFactory) {
    const vm = this;

    function goToPreview (order) {
      // used for routing
      Common.set('previewOrder', order);

      $state.go('main.order', { id: order.orderId });
    }

    function throwError (err) {
      console.log('Error in retrieving orders');
      vm.isLoadingOrders = false;
    }

    function getOrdersList () {
      vm.isLoadingOrders = true;
      ordersFactory.getOrders()
        .then(function (res) {
          vm.orders = res.orders;
          vm.isLoadingOrders = false;
        }, throwError)
        .catch(throwError);
    }

    function activate () {
      // models
      vm.orderPage = true;
      vm.orders = [];
      vm.isLoadingOrders = false;

      vm.propertyName = 'name';
      vm.reverse = true;
      vm.templateUrl = 'components/orders/orders.content.html';
      vm.showContent = true;
      vm.language = pnTopbar.language;

      // methods
      vm.goToPreview = goToPreview;
      vm.getOrdersList = getOrdersList;

      Common.set('previewOrder', null);
      console.log('OrdersController');
    }

    $scope.$on('changeLanguage', function (ev, language) {
      vm.language = language;
    });

    activate();
    getOrdersList();
  }

  angular.module('web2print.orders')
    .controller('OrdersController', OrdersController);

  OrdersController.$inject = ['Common', '$state', '$scope', 'ordersFactory'];
})();
